import { DashedTitle, Icon } from '@fasstech/middle-design-system';
import { path, prop } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { getCollegeLabel } from '../../../simulationRecap/client/helpers/collegeHelper.js';
import InformationTable from './InformationTable.jsx';
import PropTypes from 'prop-types';

export const CompanyDemographyInformations = ({
  company,
  demography,
  getMiddleBoolean,
  regimeObligatoire,
  isProjectEditable
}) => {
  const { processHandlers, context } = useProcess();

  const handleEdit = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId,
        action: 'ON_EDIT_COMPANY'
      }
    });
  };

  const collegeValue = path(['college'], demography);
  const collegeLabel = getCollegeLabel(collegeValue);
  const regimeOIP = path(['socialSecurities', '0', 'regime'], demography);
  const regime = regimeObligatoire.regimes.find(r => r.value === regimeOIP)?.label ?? '-';
  const ccnId = prop('ccnId', company);
  const ccnName = prop('ccnName', company);
  const ccnDisplayValue = (!ccnId || ccnId === '9999') ? '-' : `${ccnId} - ${ccnName}`;
  return (
    <div className=" w-full">
      <div className="w-full flex justify-center">
        <Icon name="circleCompany" size="56" />
      </div>
      <DashedTitle>Informations entreprise</DashedTitle>
      <div className="border border-gray-300 rounded-lg p-6 relative mt-4 flex flex-col gap-2">
        {/* Edit Icon */}
        {isProjectEditable && <button
          type="button"
          onClick={handleEdit}
          className=" p-2 hover:bg-gray-100 rounded-full transition-colors self-end"
          aria-label="Edit company and demography information"
        >
          <Icon
            name="circlePen"
            size="36"
            strokeClassName="stroke-primary-500"
          ></Icon>
        </button>}

        {/* Grid Container */}
        <div className="flex flex-col">
          <InformationTable
            items={[
              {
                label: 'Nom',
                value: path(['name'], company)
              },
              {
                label: 'SIRET',
                value: path(['siret'], company)
              },
              {
                label: 'CCN',
                value: ccnDisplayValue
              },
              getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_EST_NECESSAIRE') ? {
                label: 'Nombre de salariés',
                value: path(['employeeCount'], demography)
              } : null,
              {
                label: 'Catégorie du personnel',
                value: collegeLabel
              },
              getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_EST_NECESSAIRE') ? {
                label: 'Âge moyen des salariés',
                value: path(['employeeAverageAge'], demography)
              } : null,
              getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_EST_NECESSAIRE') ? {
                label: 'Nombre de conjoints',
                value: path(['partnerCount'], demography)
              } : null,
              getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_EST_NECESSAIRE') ? {
                label: 'Nombre d\'enfants',
                value: path(['childrenCount'], demography)
              } : null,
              getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_REGIME_EST_NECESSAIRE') ? {
                label: 'Régime',
                value: regime
              } : null
            ].filter(item => item !== null)}
          />
        </div>
      </div>
    </div>
  );
};

CompanyDemographyInformations.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    siret: PropTypes.string,
    ccnName: PropTypes.string
  }).isRequired,
  demography: PropTypes.shape({
    college: PropTypes.string,
    employeeCount: PropTypes.number,
    employeeAverageAge: PropTypes.number,
    partnerCount: PropTypes.number,
    childrenCount: PropTypes.number,
    customerSocialSecurityRegime: PropTypes.string
  }).isRequired,
  getMiddleBoolean: PropTypes.func
};
